import { Form, useFormApi, useFormState } from "informedv4";
import * as React from "react";
import * as Immutable from "immutable";
import { AuditForm, AuditModal } from "../../auditmodal/components/AuditModal";
import { Dropdown } from "../../forms/informedv4/DropdownV4";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { DataCorrectionRequestFormRecord } from "./DataCorrectionRequestFormRecord";
import {
    AddRecordAction,
    RemoveRecordAction,
    SelectSiteOptionAction,
    SelectSubjectOptionAction,
    SelectVisitOptionAction,
    SelectSessionOptionAction,
    SetVisibleWizardAction,
    AddMiscCorrectionAction,
    AddCorrectionAction,
    ResetFormAction,
    DcfRequestActionType,
    DcfRequestAction,
    LoadingSubjectOptionsAction,
    LoadSubjectsOptionsAction,
    LoadVisitOptionsAction,
    LoadSessionOptionsAction,
    FailedToSaveAction,
    SaveSuccessAction,
    SubmittingAction,
    ResetErrorAction,
    SetCorrectionTypeAction,
    RemoveCorrectionAction

} from "./DcfRequestActions";
import { DcfRecordState, Correction, MiscCorrection, VisibleWizards, DcfRequestState, initialDcfRequestState, defaultRecordId, VisibleWizard, correctionTypeIdToWizard } from "./DcfRequestReducer";
import { TextBox } from "../../forms/informedv4/TextBoxV4";
import { SiteOptionsSelector } from "./Selectors/SiteOptions";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { MiscCorrectionWizard } from "../Execution/CorrectionTypes/Misc/MiscCorrectionWizard";
import { SubjectTypeCorrectionWizard } from "../Execution/CorrectionTypes/SubjectType/SubjectTypeCorrectionWizard";
import { RecordingStartCorrectionWizard } from "../Execution/CorrectionTypes/RecordingStart/RecordingStartCorrectionWizard";
import { SubjectIdCorrectionWizard } from "../Execution/CorrectionTypes/SubjectId/SubjectIdCorrectionWizard";
import { SuppressSessionWizard } from "../Execution/CorrectionTypes/SuppressSession/SuppressSessionWizard";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MediaSerialCorrectionWizard } from '../Execution/CorrectionTypes/MediaSerial/MediaSerialCorrectionWizard';
import { EntityLabelCorrectionWizard } from '../Execution/CorrectionTypes/EntityLabels/EntityLabelCorrectionWizard';
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../Core/SecurityContext";
import { DcfRequest, WebPortalClient, Site, Subject, QueryOfVisit, QueryOfSession, DcfRequestStatus, DcfCorrection } from "webportalclient";
import { AttachmentRelatesTo } from "../../file-attachments/models";
import { SwapLabelsWizard } from "../Execution/CorrectionTypes/SwapLabels/SwapLabelsWizard";
import { ConfigurableDataItemIds } from "../../misc/api/ApiConfigurableDataItems";
import { CorrectionTypesEnum, DcfSystemWorkflow, DcfRequestStatusEnum, } from "../../misc/api/apiTypes";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { faEnvelope, faList, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataCorrectionRequestViewState } from "../View/DataCorrectionRequestView";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { ApiException } from "webportalclient";

export interface DataCorrectionRequestProps {
    dcfRequestState: DcfRequestState;
    dispatch: React.Dispatch<DcfRequestAction>;
    dcfRequest: DcfRequest;
}

export interface DataCorrectionRequestFormRecordsFields {
    SubjectId: string;
    VisitId: string;
    SessionId: string;
    SessionTypeId: string;
    ChangeBackground: string;
    CorrectionTypeId: string;
}

export interface DataCorrectionRequestFormFields {
    SiteId: string;
    PIName: string;
    CorrectionRecords: { [key: string]: DataCorrectionRequestFormRecordsFields; };
}

const DataCorrectionRequestReducer = (state: DcfRequestState, action: DcfRequestAction): DcfRequestState => {
    switch (action.type) {
        case DcfRequestActionType.AddRecord:
            const recordId = new Date().getTime().toString();

            return {
                ...state,
                records: [...state.records, recordId],
                visitOptionsQueries: state.visitOptionsQueries.set(recordId, {
                    query: null,
                    isLoading: false
                }),
                sessionOptionsQueries: state.sessionOptionsQueries.set(recordId, {
                    query: null,
                    isLoading: false
                }),
                corrections: state.corrections.set(recordId, []),
            };
        case DcfRequestActionType.RemoveRecord:
            return {
                ...state,
                records: state.records.filter(x => x != action.id),
                selectedSubjects: state.selectedSubjects.remove(action.id),
                selectedVisits: state.selectedVisits.remove(action.id),
                selectedSessions: state.selectedSessions.remove(action.id),
                corrections: state.corrections.remove(action.id),
                miscCorrection: state.miscCorrection.remove(action.id),
                visitOptionsQueries: state.visitOptionsQueries.remove(action.id),
                sessionOptionsQueries: state.sessionOptionsQueries.remove(action.id)
            };
        case DcfRequestActionType.SelectSubjectOption:
            const subject = state.subjectOptionsQuery.value.find(x => x.id === action.subjectId);

            return {
                ...state,
                selectedSubjects: state.selectedSubjects.set(action.recordId, subject),
            };
        case DcfRequestActionType.SetVisibleWizard:
            return {
                ...state,
                visibleWizard: {
                    recordId: action.recordId,
                    wizard: action.wizard,
                    fieldValue: action.fieldValue
                },
            };
        case DcfRequestActionType.AddCorrection:
            const currentCorrections = state.corrections.get(state.records[0]);

            let newCorrections = [...currentCorrections];
            if (currentCorrections.filter(x => x.field === action.correction.field).length == 0) {
                newCorrections = [...newCorrections, action.correction];
            } else {

                newCorrections = currentCorrections.map(c => {
                    if (c.field !== action.correction.field) {
                        return c;
                    }

                    return {
                        ...c,
                        ...action.correction,
                    };
                });
            }

            return {
                ...state,
                corrections: state.corrections.set(state.records[0], newCorrections),
            };
        case DcfRequestActionType.AddMiscCorrection:
            return {
                ...state,
                miscCorrection: state.miscCorrection.set(state.records[0], action.correction),
            };
        case DcfRequestActionType.LoadingSubjectOptions:
            return {
                ...state,
                isLoadingSubjectOptions: true
            };
        case DcfRequestActionType.LoadSubjectsOptions:
            return {
                ...state,
                subjectOptionsQuery: action.query,
                isLoadingSubjectOptions: false,
                isLoadingVisits: false,
                isLoadingSessions: false,
                sessionOptionsQueries: initialDcfRequestState.sessionOptionsQueries
            };
        case DcfRequestActionType.LoadingVisitOptions:
            let sessionRecord = state.visitOptionsQueries.get(action.recordId);

            if (sessionRecord) {
                sessionRecord.isLoading = true;
            }

            return {
                ...state,
                visitOptionsQueries: sessionRecord
                    ? state.visitOptionsQueries.set(action.recordId, sessionRecord)
                    : state.visitOptionsQueries,
                isLoadingVisits: true
            };
        case DcfRequestActionType.LoadVisitsOptions:
            return {
                ...state,
                sessionOptionsQueries: state.sessionOptionsQueries.set(action.recordId, {
                    query: {
                        value: [],
                    },
                    isLoading: false
                }),
                visitOptionsQueries: state.visitOptionsQueries.set(action.recordId, {
                    query: action.visits,
                    isLoading: false
                }),
                isLoadingVisits: false,
                isLoadingSessions: false,
            };
        case DcfRequestActionType.SelectVisitOption:
            return {
                ...state,
                selectedVisits: state.selectedVisits.set(action.recordId, action.visit),
                selectedSessions: state.selectedSessions.set(action.recordId, undefined),
            };
        case DcfRequestActionType.LoadingSessionOptions:
            let visitRecord = state.sessionOptionsQueries.get(action.recordId);

            if (visitRecord) {
                visitRecord.isLoading = true;
            }

            return {
                ...state,
                sessionOptionsQueries: visitRecord
                    ? state.sessionOptionsQueries.set(action.recordId, visitRecord)
                    : state.sessionOptionsQueries,
                isLoadingSessions: true
            };
        case DcfRequestActionType.LoadSessionOptions:
            return {
                ...state,
                sessionOptionsQueries: state.sessionOptionsQueries.set(action.recordId, {
                    query: action.query,
                    isLoading: false
                }),
                isLoadingSessions: false
            };
        case DcfRequestActionType.SelectSessionOption:
            return {
                ...state,
                selectedSessions: state.selectedSessions.set(action.recordId, action.session),
            };
        case DcfRequestActionType.SelectSiteOption:
            return {
                ...state,
                siteId: action.siteId,
                selectedSubjects: state.selectedSubjects.map(() => undefined).toMap(),
                selectedVisits: state.selectedVisits.map(() => undefined).toMap(),
                selectedSessions: state.selectedSessions.map(() => undefined).toMap(),
            };
        case DcfRequestActionType.FailedToSave:
            return {
                ...state,
                errorMessage: action.message,
                isSubmitting: false,
            };
        case DcfRequestActionType.SaveSuccess:
            return {
                ...initialDcfRequestState,
                errorMessage: null,
                failedSavingAttachment: false,
                savedRequests: action.requestIds
            };
        case DcfRequestActionType.Submitting:
            return {
                ...state,
                isSubmitting: action.isSubmitting,
                errorMessage: null,
            };
        case DcfRequestActionType.ResetError:
            return {
                ...state,
                errorMessage: null,
            };
        case DcfRequestActionType.SetCorrectionType:
            return {
                ...state,
                corrections: state.corrections.set(action.recordId, state.corrections.get(action.recordId).map(c => ({ ...c, correctionTypeId: action.correctionType })))
            };
        case DcfRequestActionType.ResetForm:
            return initialDcfRequestState;
        case DcfRequestActionType.RemoveCorrection:
            if (action.isMisc) {
                return {
                    ...state,
                    miscCorrection: state.miscCorrection.set(action.recordId, null),
                }
            }

            return {
                ...state,
                corrections: state.corrections.set(action.recordId, []),
            };
        default:
            throw new Error(`Unknown action: ${action.type}`);

    }
};

const emptyFileAttachments: Immutable.Map<string, any[]> = Immutable.Map([
    [
        defaultRecordId,
        [],
    ]
]);

export const EditDataCorrectionRequest = (props: DataCorrectionRequestProps) => {
    const { dcfRequestState, dispatch, dcfRequest } = props;
    const { study, dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions, currentUser } = useSecurityContext();
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const [siteOptions, setSiteOptions] = React.useState([]);
    const [fileAttachments, setFileAttachments] = React.useState<Immutable.Map<string, any[]>>(emptyFileAttachments);
    const [stagedDeleteIds, setStagedDeleteIds] = React.useState<string[]>([]);
    const [newFiles, setNewFiles] = React.useState<File[]>([]);
    const [disableEditFormFields, setDisableEditFormFields] = React.useState<boolean>(false);

    const formApi = useFormApi();
    const formState = useFormState();

    const dispatchInitialActions = async () => {
        const sitesResponse = await client.client.getSites("id,number", `studyId eq ${study.id}`, "number");
        setSiteOptions(SiteOptionsSelector(currentUserPermissions, sitesResponse.value));
    }

    const onReset = () => {
        dispatchInitialActions();
    }
    React.useEffect(() => {
        if (props.dcfRequest?.rejectedWithSuggestions != true) {
            setDisableEditFormFields(true);
        } else {
            setDisableEditFormFields(false);
        }
    }, [props.dcfRequest?.rejectedWithSuggestions]);

    React.useEffect(() => {
        dispatchInitialActions();
    }, []);

    React.useEffect(() => {
        const getSubjects = async () => {
            if (formState.values.SiteId) {
                dispatch(LoadingSubjectOptionsAction.create());
                const subjectsResponse = await client.client.getSubjects("id,number,status,createdWithSpirotracV,site", `siteId eq ${formState.values.SiteId}`, "number", "site");
                dispatch(LoadSubjectsOptionsAction.create(subjectsResponse));
            } else {
                dispatch(LoadSubjectsOptionsAction.create({ value: [] }));
                for (let recordId of props.dcfRequestState.records) {
                    formApi.setValue(`CorrectionRecords[${recordId}].SubjectId`, "");
                    props.dispatch(SelectSubjectOptionAction.create(recordId, undefined));
                    props.dispatch(LoadVisitOptionsAction.create(recordId, { value: [] }));
                    props.dispatch(LoadSessionOptionsAction.create(recordId, { value: [] }));
                }
            }
        }

        getSubjects();
    }, [formState.values.SiteId]);

    React.useEffect(() => {
        if (props.dcfRequest?.corrections && props.dcfRequest?.correctionTypeId != CorrectionTypesEnum.Miscellaneous) {

            const mapDcfToCorrections = (dcfs: DcfCorrection[]): Correction[] =>
                dcfs
                    .filter(dc => !!dc.entity && !!dc.field)
                    .map<Correction>(dc => ({
                        sourceCorrection: correctionTypeIdToWizard[props.dcfRequest?.correctionTypeId!] ?? null,
                        correctionTypeId: props.dcfRequest?.correctionTypeId,
                        entity: dc.entity ?? "",
                        field: dc.field ?? "",
                        oldValue: dc.originalValue ?? null,
                        newValue: dc.correctedValue ?? null,
                    })
                    );

            const corrections: Correction[] = mapDcfToCorrections(props.dcfRequest?.corrections);
            dispatch(AddCorrectionAction.create(corrections[0]));
        }
        else if (props.dcfRequest?.correctionTypeId == CorrectionTypesEnum.Miscellaneous) {
            const miscCorrection = {
                fromDetails: props.dcfRequest?.originalEntry,
                toDetails: props.dcfRequest?.newEntry
            }

            dispatch(AddMiscCorrectionAction.create(miscCorrection));

        }
    }, [props.dcfRequest?.corrections])

    React.useEffect(() => {
        if (!props.dcfRequest) return;

        const subjectId = String(
            props.dcfRequest.subject?.id ?? props.dcfRequest.subjectId ?? ""
        );
        if (!subjectId) return;

        const subjectOptions = props.dcfRequestState.subjectOptionsQuery?.value ?? [];
        if (!subjectOptions.length) return;

        for (const r of props.dcfRequestState.records) {
            if (!props.dcfRequestState.selectedSubjects.get(r)) {
                const subjectObj = subjectOptions.find(s => String(s.id) === subjectId);
                if (subjectObj) {
                    props.dispatch(SelectSubjectOptionAction.create(r, subjectObj?.id));

                    formApi.setValue(`CorrectionRecords["${r}"].SubjectId`, subjectId);
                }
            }
        }
    }, [props.dcfRequest?.subject?.id, props.dcfRequest?.subjectId, props.dcfRequestState.subjectOptionsQuery?.value, props.dcfRequestState.records, formApi]);


    React.useEffect(() => {
        if (!props.dcfRequest) return;

        const sessionId = String(
            props.dcfRequest.session?.id ?? props.dcfRequest.sessionId ?? ""
        );
        if (!sessionId) return;

        for (const r of props.dcfRequestState.records) {

            const selectedVisit = props.dcfRequestState.selectedVisits.get(r);
            if (!selectedVisit) continue;

            const sessionsState = props.dcfRequestState.sessionOptionsQueries.get(r);
            const sessionOptions = sessionsState?.query?.value ?? [];
            if (!sessionOptions.length) continue;

            if (props.dcfRequestState.selectedSessions.get(r)) continue;

            const sessionObj = sessionOptions.find(s => String(s.id) === sessionId);
            if (!sessionObj) continue;

            props.dispatch(
                SelectSessionOptionAction.create(
                    r,
                    sessionObj,
                    props.dcfRequestState.records.indexOf(r),
                    formApi
                )
            );

            formApi.setValue(`CorrectionRecords["${r}"].SessionId`, sessionId);
        }
    }, [props.dcfRequest?.session?.id, props.dcfRequest?.sessionId, props.dcfRequestState.selectedVisits, props.dcfRequestState.sessionOptionsQueries, props.dcfRequestState.records, formApi]);

    React.useEffect(() => {
        const getInitialFormValues = async () => {

            formApi.setValue("PrincipalInvestigatorName", dcfRequest?.site?.contact);
            formApi.setValue(`SiteId`, dcfRequest?.site?.id);
        }

        getInitialFormValues();
    }, [dcfRequest?.site?.contact]);

    React.useEffect(() => {
        const getPrincipalInvestigator = async () => {
            if (formState.values.SiteId) {
                const siteResponse = await client.client.getSite(formState.values.SiteId as string, "contact");

                formApi.setValue("PrincipalInvestigatorName", siteResponse?.contact);
            }
        }

        getPrincipalInvestigator();
    }, [formState.values.SiteId]);

    const mapCorrections = (corrections: Correction[]) => {
        if (!corrections) {
            return [];
        }

        return corrections.map(c => ({ field: c.field, entity: c.entity, originalValue: c.oldValue, correctedValue: c.newValue }));
    }

    const handleStageDelete = (id: string) =>
        setStagedDeleteIds(prev => [...prev, id]);

    const handleNewFilesUpdated = (files: File[]) => {
        setNewFiles(files);
    };

    const handleUploaderFilesUpdated = (files: File[]) => {
        handleNewFilesUpdated?.(files);
    };

    const onSubmit = async (auditAnnotation: string) => {
        dispatch(SubmittingAction.create(true));
        formApi.validate();

        const form = formApi.getFormState();

        const hasAllSitePermission = currentUserPermissions.find(cup => cup.Id === PermissionEnum.CreateAllSiteDataCorrection);

        if (!hasAllSitePermission && (form.values.SiteId === undefined || form.values.SiteId === null)) {
            dispatch(SubmittingAction.create(false));
            formApi.setError("SiteId", "A site selection is required");
            return dispatch(FailedToSaveAction.create("A site selection is required"));
        }

        if (form.invalid) {
            dispatch(SubmittingAction.create(false));
            return dispatch(FailedToSaveAction.create("Errors exist on the page"));
        }


        const requests: Array<DcfRequest> = [];
        const records = Object.values(form.values.CorrectionRecords).filter(x => x !== null);

        // TODO: Clean this up, we should be using either record keys or indexes but not a combination of both

        const record = records[0];
        const recordKey = dcfRequestState.records[0];

        const recordCorrections = dcfRequestState.corrections.get(recordKey);
        const recordMiscCorrections = dcfRequestState.miscCorrection.get(recordKey);

        if ((!recordCorrections || recordCorrections.length === 0) && (recordMiscCorrections === null || recordMiscCorrections === undefined)) {
            return dispatch(FailedToSaveAction.create("At least one correction is required within the request"));
        }

        const errors: { id: string; error: unknown }[] = [];

        if (currentUserPermissions.some(x => x.Id === PermissionEnum.DeleteFile)) {
            for (const id of stagedDeleteIds) {
                try {
                    await client.client.deleteFile(id);
                } catch (err) {
                    errors.push({ id, error: err });
                }
            }

            if (errors.length) {
                console.error("Some attachment deletions failed", errors);
                return;
            }
        }

        try {
            const request = await client.client.patchDcfRequest({
                studyId: study.id,
                siteId: form.values.SiteId as string,
                createdByUser: currentUser.Username,
                subjectId: record.SubjectId === "All" ? null : record.SubjectId != undefined ? record.SubjectId : null,
                visitId: record.VisitId === "All" ? null : record.VisitId != undefined ? record.VisitId : null,
                sessionId: record.SessionId === "All" ? null : record.SessionId != undefined ? record.SessionId : null,
                additionalComments: record.ChangeBackground,
                originalEntry: recordMiscCorrections ? recordMiscCorrections.fromDetails : null,
                newEntry: recordMiscCorrections ? recordMiscCorrections.toDetails : null,
                corrections: recordCorrections.length > 0 ? mapCorrections(recordCorrections) : [],
                rejectedWithSuggestions: false,
                correctionTypeId: recordCorrections.length > 0 ? recordCorrections[0].correctionTypeId : recordMiscCorrections != null ? CorrectionTypesEnum.Miscellaneous : dcfRequest?.correctionTypeId,
                status: DcfRequestStatusEnum.SiteApproval,
                siteApproved: false,
                siteApprovedByUser: null,
            }, dcfRequest.id, auditAnnotation);

            for (const file of fileAttachments.get(recordKey) ?? []) {
                const fileResult = await legacyClient.postFile(study.id, AttachmentRelatesTo.DcfRequest, request.id, file);

                if (fileResult.Errors) {
                    return dispatch(FailedToSaveAction.create(fileResult.Errors.map(e => e.Message).join(",")));
                }
            }

            requests.push(request);
        } catch (ex) {
            if (ex.message) {
                return dispatch(FailedToSaveAction.create(ex.message));
            }

            return dispatch(FailedToSaveAction.create("Failed to save the request to the server"));
        }

        dispatch(SaveSuccessAction.create(requests));
        dispatch(SubmittingAction.create(false));
        formApi.reset();
        formApi.disable();
        setDisableEditFormFields(true);
        if (document && document.documentElement) {
            document.documentElement.scrollTop = 0;
        }
    }

    return (
        <>
            <Alert
                show={dcfRequestState.errorMessage !== null}
                category={AlertCategoryEnum.Danger}
            >
                {dcfRequestState.errorMessage}
            </Alert>
            <Alert
                show={false} //props.failedSavingAttachments was unset, making this alert useless
                category={AlertCategoryEnum.Danger}
            >
                Failed to save an attachment linked to the current DCF request, cancelled
                further DCF request submission
            </Alert>
            <EditDataCorrectionRequestForm {...props}
                siteOptions={siteOptions}
                selectedSubjects={dcfRequestState.selectedSubjects}
                fileAttachments={fileAttachments}
                records={dcfRequestState.records}
                corrections={dcfRequestState.corrections}
                miscCorrections={dcfRequestState.miscCorrection}
                onReset={onReset}
                setFileAttachments={setFileAttachments}
                dispatch={dispatch}
                dcfRequestState={dcfRequestState}
                onSubmit={(annotation) => onSubmit(annotation)}
                onFileAttachmentsUpdated={handleNewFilesUpdated}
                onStageExistingDelete={handleStageDelete}
                stagedDeleteIds={stagedDeleteIds}
                handleUploaderFilesUpdated={handleUploaderFilesUpdated}
                disableEditFormFields={disableEditFormFields}
            />
        </>
    );
}

export interface EditDataCorrectionRequestFormProps {
    records: string[];
    siteOptions: Site[];
    selectedSubjects: Immutable.Map<string, Subject>;
    corrections: Immutable.Map<string, Array<Correction>>;
    miscCorrections: Immutable.Map<string, MiscCorrection>;
    fileAttachments: Immutable.Map<string, any[]>;
    onReset: () => void;
    setFileAttachments: any;
    dispatch: React.Dispatch<DcfRequestAction>;
    dcfRequestState: DcfRequestState;
    onSubmit: (annotation: string) => void;
    dcfRequest: DcfRequest;
    handleUploaderFilesUpdated?: any
    onStageExistingDelete?: any;
    stagedDeleteIds?: any;
    onFileAttachmentsUpdated?: any;
    disableEditFormFields?: boolean;
}

export const EditDataCorrectionRequestForm = (props: EditDataCorrectionRequestFormProps) => {
    const formApi = useFormApi();
    const formState = useFormState();
    const [showAuditModal, setShowAuditModal] = React.useState<boolean>(false);
    const [submitting, setSubmitting] = React.useState(false);

    const onSubmit = (auditAnnotation: string) => {
        setShowAuditModal(false);
        setSubmitting(true);
        props.dispatch(ResetErrorAction.create());
        formApi.validate();

        const form = formApi.getFormState();

        if (form.invalid) {
            setSubmitting(false);
            return props.dispatch(FailedToSaveAction.create("Errors exist on the page"));
        }

        if (!hasCorrections()) {
            setSubmitting(false);
            return props.dispatch(FailedToSaveAction.create("At least one data correction is required"));
        }

        props.onSubmit(auditAnnotation);
        setSubmitting(false);

    };

    const onReset = formApi => {
        props.setFileAttachments(emptyFileAttachments);
        props.dispatch(ResetFormAction.create());
        formApi.reset();
        //After reset, firing the initial requests for sites etc as the component has been reset.
        props.onReset();
    };

    const queryDataSelector = (
        queryMap: Immutable.Map<string, DcfRecordState<any>>,
        recordId: string
    ): DcfRecordState<any> => {
        if (queryMap.get(recordId) === undefined) {
            return null;
        }

        return queryMap.get(recordId);
    };

    const hasAnyFileAttachments = () => {
        return props.fileAttachments.some(fa => fa.length > 0);
    }

    const hasCorrections = () => {
        return (
            !!props.corrections.find(corrections => !!corrections && corrections.length > 0) ||
            !!props.miscCorrections.find(mc => !!mc)
        );
    }

    const renderRecords = (formApi: any) => {
        return (
            <>
                {props.records.map((r, index) => {
                    const sessions: DcfRecordState<QueryOfSession> = queryDataSelector(
                        props.dcfRequestState.sessionOptionsQueries,
                        r
                    );
                    const visits: DcfRecordState<QueryOfVisit> = queryDataSelector(
                        props.dcfRequestState.visitOptionsQueries,
                        r
                    );

                    return (
                        <DataCorrectionRequestFormRecord
                            key={`Record${r}`}
                            setRecordFileAttachmentUploader={() => { }}
                            recordId={r}
                            recordIndex={index}
                            subjectOptions={props.dcfRequestState.subjectOptionsQuery?.value ?? []}
                            visits={visits}
                            sessions={sessions}
                            selectedSubject={props.selectedSubjects.get(r)}
                            selectedVisit={props.dcfRequestState.selectedVisits.get(r)}
                            selectedSession={props.dcfRequestState.selectedSessions.get(r)}
                            isEditFormRecord={true}
                            isRemoveRecordButtonDisabled={props.records.length === 1}
                            isLoadingSubjectOptions={props.dcfRequestState.isLoadingSubjectOptions}
                            corrections={props.corrections.get(r)}
                            miscCorrection={props.miscCorrections.get(r)}
                            dispatch={props.dispatch}
                            dcfRequestState={props.dcfRequestState}
                            onRemoveClick={id => props.dispatch(RemoveRecordAction.create(id))}
                            onFileAttachmentChanged={(fa) => {
                                props.setFileAttachments(props.fileAttachments.set(r, fa));
                            }}

                            onSubjectChange={subjectId => {
                                props.dispatch(
                                    SelectSubjectOptionAction.create(r, subjectId)
                                );

                                props.dispatch(
                                    SelectVisitOptionAction.create(r, null, index)
                                );

                                props.dispatch(
                                    SelectSessionOptionAction.create(r, null, index, formApi)
                                );

                                formApi.setValue(`CorrectionRecords["${r}"].VisitId`, "");
                                formApi.setValue(`CorrectionRecords["${r}"].SessionId`, "");
                            }}
                            onVisitChange={v => {
                                props.dispatch(
                                    SelectVisitOptionAction.create(
                                        r,
                                        visits.query.value.find(x => x.id == v),
                                        index
                                    )
                                )

                                props.dispatch(
                                    SelectSessionOptionAction.create(r, null, index, formApi)
                                );

                                formApi.setValue(`CorrectionRecords["${r}"].SessionId`, "");
                            }}
                            onSessionChange={s =>
                                props.dispatch(
                                    SelectSessionOptionAction.create(
                                        r,
                                        sessions.query.value.find(x => x.id == s),
                                        index,
                                        formApi
                                    )
                                )
                            }
                            dcfRequest={props.dcfRequest}
                            onFileAttachmentsUpdated={props.onFileAttachmentsUpdated}
                            onStageExistingDelete={props.onStageExistingDelete}
                            stagedDeleteIds={props.stagedDeleteIds}
                            disableEditFormFields={props.disableEditFormFields}
                        />
                    )
                })}
            </>
        );
    };

    var navigate = useNavigate();

    return (
        <>
            <fieldset disabled={props.disableEditFormFields}>
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Edit a Data Correction Request: {props.dcfRequest?.label}</h2>
                    </div>
                </div>
                {!props.dcfRequest?.rejectedWithSuggestions ?
                    <div className="panel panel-default">
                        <Alert show={true} category={AlertCategoryEnum.Warning}>
                            This Data Correction has already been resubmitted and cannot be edited currently
                        </Alert>
                    </div>
                    : null}
                <Alert
                    show={props.dcfRequestState.savedRequests.length > 0}
                    category={AlertCategoryEnum.Success}
                >
                    Data correction request updated, reference number:{" "}
                    {props.dcfRequestState.savedRequests.map(r => (
                        <React.Fragment key={`DcfRequestLink-${r.id}`}>
                            <Link to={`/Dcf/View/${r.id}`}>
                                {r.label}
                            </Link>{" "}
                        </React.Fragment>
                    ))}
                </Alert>
                <div className="row">
                    <div className="col-md-12">
                        {!props.disableEditFormFields && props.dcfRequest?.rejectedWithSuggestions && props.dcfRequest?.rejectedWithSuggestionsAnnotation ?
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h3 className="panel-title">Suggestions / Reason for Data Correction Rejection</h3>
                                </div>
                                <Alert show={true} category={AlertCategoryEnum.Warning}>
                                    {props.dcfRequest?.rejectedWithSuggestionsAnnotation}
                                </Alert>
                            </div>
                            : null}
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="form-group col-md-6">
                                    <label htmlFor="select-site">Site</label>
                                    <Dropdown
                                        name="SiteId"
                                        id="select-site"
                                        disabled={hasCorrections() || props.disableEditFormFields}
                                        field="SiteId"
                                        className="form-control"
                                        onChange={e => {
                                            props.dispatch(
                                                SelectSiteOptionAction.create(
                                                    (e as any).target.value,
                                                    formApi
                                                )
                                            );

                                            for (const recordId of props.records) {

                                                props.dispatch(SelectSubjectOptionAction.create(recordId, null));

                                                props.dispatch(SelectVisitOptionAction.create(recordId, null, props.records.indexOf(recordId)));

                                                props.dispatch(SelectSessionOptionAction.create(recordId, null, props.records.indexOf(recordId), formApi));

                                                formApi.setValue(`CorrectionRecords["${recordId}"].SubjectId`, "");
                                                formApi.setValue(`CorrectionRecords["${recordId}"].VisitId`, "");
                                                formApi.setValue(`CorrectionRecords["${recordId}"].SessionId`, "");
                                            }
                                        }}
                                    >
                                        <option
                                            key={"OptionSiteBlank"}
                                            value={[]}
                                        />
                                        {props.siteOptions.map(so => (
                                            <option
                                                key={`Option${so.id}`}
                                                value={so.id}
                                            >
                                                {so.number}
                                            </option>
                                        ))}
                                    </Dropdown>
                                </div>
                                <div className="form-group col-md-6">
                                    <label htmlFor="piName">
                                        Principal Investigator Name
                                    </label>
                                    <TextBox
                                        name="PrincipalInvestigatorName"
                                        id="input-principalInvestigatorName"
                                        field="PrincipalInvestigatorName"
                                        readOnly
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>

                        {renderRecords(formApi)}
                    </div>
                </div>
            </fieldset>
            <div className="row">
                <div className="col-md-6">
                    <button
                        className="btn btn-primary btn-outline"
                        type="button"
                        disabled={
                            !formState.dirty && !hasAnyFileAttachments() || props.disableEditFormFields
                        }
                        onClick={() => onReset(formApi)}
                    >
                        <FontAwesomeIcon icon={faRotateLeft} /> Reset Form
                    </button>
                </div>
                <div className="col-md-6 text-right">
                    <button
                        className="btn btn-primary btn-outline"
                        type="button"
                        disabled={props.dcfRequestState.isSubmitting}
                        onClick={() =>
                            navigate("/Dcf")
                        }
                    >
                        Return to List
                    </button>
                    &nbsp;
                    <button
                        className="btn btn-primary"
                        type="submit"
                        onClick={() => setShowAuditModal(true)}
                        disabled={props.dcfRequestState.isSubmitting || !props.dcfRequest?.rejectedWithSuggestions || props.disableEditFormFields}
                    >
                        <FontAwesomeIcon icon={faEnvelope} /> Submit
                    </button>
                </div>
                {showAuditModal ? <AuditModal onSubmit={(form) => onSubmit(form.Annotation)} onClose={() => setShowAuditModal(false)} isSubmitting={submitting} header="Edit Data Correction Request" /> : null}
            </div>
            <br />
        </>
    );
}

export const EditDataCorrectionRequestWrapper = ({ dcfRequestId = null, onClose = null }) => {
    const params = useParams<{ dcfRequestId: string }>();
    var navigate = useNavigate();

    dcfRequestId = dcfRequestId ?? params.dcfRequestId;
    if (onClose == undefined) {
        onClose = () => {
            navigate('/Dcf');
        }
    }

    const [systemWorkflow, setSystemWorkflow] = React.useState<DcfSystemWorkflow>();
    const [errorMessage, setErrorMessage] = React.useState<string | undefined>();


    const client = useWebPortalApiClient();
    const [dcfRequest, setDcfRequest] = React.useState<DcfRequest>();
    const [statuses, setStatuses] = React.useState<DcfRequestStatus[]>();
    const [labels, setLabels] = React.useState<string[]>();
    const [verificationApprovalEnabled, setVerificationApprovalEnabled] = React.useState(false);
    const [corrections, setCorrections] = React.useState<Correction[]>([]);
    const [miscCorrection, setMiscCorrection] = React.useState<MiscCorrection>();

    const { dataItemConfigurationCollection, study } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();
    const getDcfRequest = async (id: string) => {
        try {
            const dcfRequestResponse = await client.client.getDcfRequest(id, undefined, "corrections,site,subject,visit,session");
            setDcfRequest(dcfRequestResponse);
        } catch (ex) {
            if ((ex as ApiException).status === 404) {
                setErrorMessage("The Data Correction cannot be found");
                return;
            }
            setErrorMessage("Error loading the Data Correction");
        }
    }

    React.useEffect(() => {
        if (dcfRequestId == null) return;
        const loadDcfRequest = async () => {
            const craEnabled = await legacyClient.getSetting("dcf.configuration.verificationApprovalEnabled", study.id);
            setVerificationApprovalEnabled(craEnabled);

            const dcfSettings = await legacyClient.getStudyDcfSettings(study.id)
            setSystemWorkflow(dcfSettings.SystemWorkflow);

            const statusesResponse = await client.client.getDcfRequestStatuses(undefined, craEnabled ? undefined : `id ne '${DcfRequestStatusEnum.VerificationReview}'`);
            setStatuses(statusesResponse.value);

            const dcfLabelsResponse = await client.client.getDcfRequests("label");
            setLabels(dcfLabelsResponse.value.map(l => l.label));

            getDcfRequest(dcfRequestId);

        };

        loadDcfRequest();
    },
        [dcfRequestId, study.id]
    );

    const [dcfRequestState, dispatch] = React.useReducer(DataCorrectionRequestReducer, initialDcfRequestState);

    const dispatchAddCorrections = (corrections: Correction[]) => {
        for (let i = 0; i < corrections.length; i++) {
            dispatch(AddCorrectionAction.create(corrections[i]));
        }

        dispatch(
            SetVisibleWizardAction.create(null, null, null)
        );
    }

    const dispatchRemoveCorrection = () => {
        dispatch(RemoveCorrectionAction.create(dcfRequestState.records[0], false));
    }

    const dispatchRemoveMiscCorrection = () => {
        dispatch(RemoveCorrectionAction.create(dcfRequestState.records[0], true));
    }

    const dispatchSetCorrectionType = (recordId: string, correctionType: CorrectionTypesEnum) => {
        dispatch(SetCorrectionTypeAction.create(recordId, correctionType));
    }

    const subjectConfig = () => dataItemConfigurationCollection.find(dic => dic.configurableDataItemId == ConfigurableDataItemIds.SubjectId);

    React.useEffect(() => {
        if (dcfRequest?.corrections && dcfRequest?.correctionTypeId != CorrectionTypesEnum.Miscellaneous) {

            const mapDcfToCorrections = (dcfs: DcfCorrection[]): Correction[] =>
                dcfs
                    .filter(dc => !!dc.entity && !!dc.field)
                    .map<Correction>(dc => ({
                        sourceCorrection: correctionTypeIdToWizard[dcfRequest?.correctionTypeId!] ?? null,
                        correctionTypeId: dcfRequest?.correctionTypeId,
                        entity: dc.entity ?? "",
                        field: dc.field ?? "",
                        oldValue: dc.originalValue ?? null,
                        newValue: dc.correctedValue ?? null,
                    })
                    );

            const corrections: Correction[] = mapDcfToCorrections(dcfRequest?.corrections);
            setCorrections(corrections);
            dispatchRemoveCorrection();
            dispatchRemoveMiscCorrection();
            dispatchAddCorrections(corrections);
        }
        else if (dcfRequest?.correctionTypeId == CorrectionTypesEnum.Miscellaneous) {
            const miscCorrection = {
                fromDetails: dcfRequest?.originalEntry,
                toDetails: dcfRequest?.newEntry
            }

            setMiscCorrection(miscCorrection);
            dispatchRemoveCorrection();
            dispatchRemoveMiscCorrection();
            dispatch(AddMiscCorrectionAction.create(miscCorrection));
        }
    }, [dcfRequest?.corrections])

    return (
        <DocumentTitle title="Edit a Data Correction | Vitalograph Web Portal">
            <Form validateOn="submit" id="editDcfForm">
                <EditDataCorrectionRequest
                    dcfRequestState={dcfRequestState}
                    dispatch={dispatch}
                    dcfRequest={dcfRequest}
                />
            </Form>
            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.Misc ? (<MiscCorrectionWizard
                    correction={dcfRequestState.miscCorrection.get(dcfRequestState.visibleWizard.recordId)}
                    isVisible={dcfRequestState.visibleWizard.wizard === VisibleWizards.Misc}
                    onClose={() =>
                        dispatch(SetVisibleWizardAction.create(null, null, null))
                    }
                    onComplete={correction => {
                        dispatchRemoveCorrection();
                        dispatchRemoveMiscCorrection();
                        dispatch(AddMiscCorrectionAction.create(correction));
                        dispatch(SetCorrectionTypeAction.create(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.Miscellaneous));
                        dispatch(SetVisibleWizardAction.create(null, null, null));
                    }}
                />) : null}
            </ErrorBoundary>
            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.SessionSuppress ? <SuppressSessionWizard
                    correctedSuppressState={
                        dcfRequestState.corrections?.get(dcfRequestState.visibleWizard.recordId)[0]?.correctionTypeId == "CR_SESSION_SUPPRESS" ?
                            dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId) &&
                            dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId)[0] &&
                            dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId)[0].newValue
                            : null}
                    originalSuppressState={dcfRequestState.visibleWizard.fieldValue}
                    isVisible={dcfRequestState.visibleWizard.wizard === VisibleWizards.SessionSuppress}
                    onClose={
                        () =>
                            dispatch(SetVisibleWizardAction.create(null, null, null))
                    }
                    onComplete={(corrections) => {
                        dispatchRemoveMiscCorrection();
                        dispatchRemoveCorrection();
                        dispatchAddCorrections(corrections);
                        dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.SessionSuppress);
                    }} /> : null}
            </ErrorBoundary>
            <ErrorBoundary>

                {dcfRequestState.visibleWizard.wizard === VisibleWizards.RecordingStart ? (<RecordingStartCorrectionWizard
                    isVisible={
                        dcfRequestState.visibleWizard.wizard === VisibleWizards.RecordingStart
                    }
                    sessionCurrentDateTime={dcfRequestState.visibleWizard.fieldValue}
                    onClose={() =>
                        dispatch(SetVisibleWizardAction.create(null, null, null))
                    }
                    onComplete={(corrections) => {
                        dispatchRemoveMiscCorrection();
                        dispatchRemoveCorrection();
                        dispatchAddCorrections(corrections);
                        dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.RecordingStart);
                    }}
                />) : null}

            </ErrorBoundary>
            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.SubjectNumber ? (<SubjectIdCorrectionWizard
                    subjectIdFieldDisplayText={subjectConfig().displayText}
                    isVisible={
                        dcfRequestState.visibleWizard.wizard === VisibleWizards.SubjectNumber
                    }
                    siteNumber={dcfRequestState.selectedSubjects.get(dcfRequestState.visibleWizard.recordId).site.number}
                    originalSubjectId={dcfRequestState.visibleWizard.fieldValue}
                    correctedSubjectId={
                        dcfRequestState.corrections?.get(dcfRequestState.visibleWizard.recordId)[0]?.correctionTypeId == "CR_SUBJECT_NUMBER" ?
                            dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId) &&
                            dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId)[0] &&
                            dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId)[0].newValue
                            : null}
                    onClose={() =>
                        dispatch(SetVisibleWizardAction.create(null, null, null))
                    }
                    onComplete={(corrections) => {
                        dispatchRemoveMiscCorrection();
                        dispatchRemoveCorrection();
                        dispatchAddCorrections(corrections);
                        dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.SubjectNumber);
                    }}
                />) : null}

            </ErrorBoundary>
            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.SubjectType ? (
                    <SubjectTypeCorrectionWizard
                        isVisible={
                            dcfRequestState.visibleWizard.wizard === VisibleWizards.SubjectType
                        }
                        originalSubjectType={dcfRequestState.visibleWizard.fieldValue}
                        correctedSubjectType={
                            dcfRequestState.corrections?.get(dcfRequestState.visibleWizard.recordId)[0]?.correctionTypeId == "CR_SUBJECT_TYPE" ?
                                dcfRequestState.corrections.get(
                                    dcfRequestState.visibleWizard.recordId
                                ) &&
                                dcfRequestState.corrections.get(
                                    dcfRequestState.visibleWizard.recordId
                                )[0] &&
                                dcfRequestState.corrections.get(
                                    dcfRequestState.visibleWizard.recordId
                                )[0].newValue
                                : null}
                        onClose={() =>
                            dispatch(
                                SetVisibleWizardAction.create(null, null, null)
                            )
                        }
                        onComplete={(corrections) => {
                            dispatchRemoveMiscCorrection();
                            dispatchRemoveCorrection();
                            dispatchAddCorrections(corrections);
                            dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.SubjectType);
                        }}
                    />
                ) : null}
            </ErrorBoundary>
            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.EntityLabels ? <EntityLabelCorrectionWizard
                    studyId={study.id}
                    siteId={dcfRequestState.siteId}
                    isVisible={dcfRequestState.visibleWizard.wizard === VisibleWizards.EntityLabels}
                    subjectIdFieldDisplayText={subjectConfig().displayText}
                    originalValue={dcfRequestState.visibleWizard.fieldValue}
                    savedCorrections={dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId)?.filter(c => c.sourceCorrection === VisibleWizards.EntityLabels)}
                    onClose={() =>
                        dispatch(SetVisibleWizardAction.create(null, null, null))
                    }
                    onComplete={(corrections) => {
                        dispatchRemoveMiscCorrection();
                        dispatchRemoveCorrection();
                        dispatchAddCorrections(corrections);
                        dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.MoveSession);
                    }}
                /> : null}
            </ErrorBoundary>
            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.MediaSerial ? (<MediaSerialCorrectionWizard
                    isVisible={
                        dcfRequestState.visibleWizard.wizard === VisibleWizards.MediaSerial
                    }
                    originalMediaSerial={dcfRequestState.visibleWizard.fieldValue}
                    savedCorrections={dcfRequestState.corrections.get(dcfRequestState.visibleWizard.recordId)?.filter(c => c.sourceCorrection === VisibleWizards.MediaSerial)}
                    onClose={() =>
                        dispatch(SetVisibleWizardAction.create(null, null, null))
                    }
                    onComplete={(corrections) => {
                        dispatchRemoveMiscCorrection();
                        dispatchRemoveCorrection();
                        dispatchAddCorrections(corrections);
                        dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.MediaSerial);
                        dispatch(SetVisibleWizardAction.create(null, null, null));
                    }}
                />) : null}

            </ErrorBoundary>

            <ErrorBoundary>
                {dcfRequestState.visibleWizard.wizard === VisibleWizards.SwapLabels ? <Form
                    initialValues={
                        {
                            Subject: dcfRequestState.visibleWizard.fieldValue.subject.id,
                        }
                    }
                ><SwapLabelsWizard
                        isVisible={dcfRequestState.visibleWizard.wizard === VisibleWizards.SwapLabels}
                        subjectIdFieldDisplayText={subjectConfig().displayText}
                        originalValue={dcfRequestState.visibleWizard.fieldValue}
                        siteId={dcfRequest?.siteId}
                        onClose={() =>
                            dispatch(SetVisibleWizardAction.create(null, null, null))
                        }
                        onComplete={(corrections) => {
                            dispatchRemoveMiscCorrection();
                            dispatchRemoveCorrection();
                            dispatchAddCorrections(corrections);
                            dispatchSetCorrectionType(dcfRequestState.visibleWizard.recordId, CorrectionTypesEnum.SwapLabels);
                        }}
                    /></Form> : null}
            </ErrorBoundary>
        </DocumentTitle>
    );
}

export default EditDataCorrectionRequestWrapper;
